export default __webpack_public_path__ + "4b4f712dfc3b112b226f8336b143b930.svg";